(() => { const start = () => document.querySelectorAll('[data-skn-footer-country]').forEach(select => { if (select.dataset.ready) return; select.dataset.ready = 'true'; select.addEventListener('change', () => select.form.requestSubmit()); }); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start(); document.addEventListener('shopify:section:load', start); })();
(() => {
  let privacyReady;
  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!privacyReady) privacyReady = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) return reject(new Error('Privacy API unavailable'));
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (error) { privacyReady = undefined; reject(error); }
        else resolve(window.Shopify.customerPrivacy);
      });
    });
    return privacyReady;
  };
  let opener;
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-skn-manage-cookies]');
    const close = event.target.closest('[data-skn-cookie-close]');
    if (close) { close.closest('dialog').close(); opener?.focus(); return; }
    if (!link) return;
    event.preventDefault();
    const dialog = link.closest('.skn-footer-organized').querySelector('[data-skn-cookie-preferences]');
    if (!dialog || dialog.open) return;
    opener = link;
    const status = dialog.querySelector('[role="status"]');
    const save = dialog.querySelector('[type="submit"]');
    status.textContent = '';
    save.disabled = true;
    dialog.showModal();
    try {
      const privacy = await loadPrivacy();
      const consent = privacy.currentVisitorConsent();
      dialog.querySelectorAll('[name]').forEach(input => { input.checked = consent[input.name] === 'yes'; });
      save.disabled = false;
    } catch { status.textContent = dialog.dataset.error; }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-skn-cookie-form]');
    if (!form) return;
    event.preventDefault();
    const dialog = form.closest('dialog');
    const save = form.querySelector('[type="submit"]');
    save.disabled = true;
    try {
      const privacy = await loadPrivacy();
      const consent = {};
      form.querySelectorAll('[name]').forEach(input => { consent[input.name] = input.checked; });
      privacy.setTrackingConsent(consent, () => { dialog.close(); save.disabled = false; opener?.focus(); });
    } catch {
      dialog.querySelector('[role="status"]').textContent = dialog.dataset.error;
      save.disabled = false;
    }
  });
})();
